/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// The avatar address is obtained from the cdn address and is consistent with the user's uploaded avatar logic.
// Use path without host to facilitate migration of data for privatized versions
// Maintain Address: https://vika.cn/space/spcBcZN1UZZJz/workbench/dstbbxEQsgj4n5YoY3/viwyjWJEgnapf/rec82hjVdPPd3

export const defaultAvatars = [
  'space/2020/09/11/e6aa3037a38f45acb65324ea314aea58',
  'space/2021/03/10/61a8aae11da2439ebb4df35b9075587d',
  'space/2020/09/11/41e723917dc742d2974e41abab8cf60b',
  'space/2020/09/11/4dce50e4ec4649b9a408a494aca28183',
  'space/2020/09/11/e4d073b1fa674bc884a8c194e9248ecf',
  'space/2020/09/11/31a1acb4734c4dd3ae9538299282b39e',
];
